import React from 'react'

import './TabButton.css'

type Props = {
  onClick?: () => void
  label: string
  active?: boolean
  mode?: string
}

export const TabButton = ({ onClick, label, active, mode }: Props) => {
  return (
    <button
      className={`will-filter-bar-tab-button ${mode || 'light'} ${
        active && 'active'
      } `}
      onClick={onClick}
    >
      {label}
    </button>
  )
}
